export const BRAND = {
  name: "Hup Ley Huat",
  fullName: "Hup Ley Huat Motor Spray Painting Svcs",
  tagline: "Quality You Can See · Since 1988",
  zh: "合利发汽车喷漆",
  emblem: "/brand/emblem.png",
  logo: "/brand/logo.jpg",
};
